module.exports = __webpack_public_path__ + "static/media/grant-agreement.b3a50628.svg";